import * as types from "./mutation-types";

const mutations = {
  [types.DARK_MODE_TOGGLE](state, status) {
    state.darkMode = status;
  },

  [types.SET_IS_MOBILE](state, status) {
    state.isMobile = status;
  },

  [types.SET_EXPANDED](state, status) {
    state.expanded = status;
  }
};

export default mutations;
